import '../scss/frontend.scss';
import Sliders from './components/swiper-init';
function ready() {
    const header = document.querySelector('.site-header');
    let isSafari = false;
    const ua = navigator.userAgent;
    if (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS/.test(ua)) {
        isSafari = true;
    }
    if (isSafari) {
        document.documentElement.classList.add('safari');
    }
    Sliders.initBlogHeroSlider();
    window.document.addEventListener('scroll', () => {
        const operationType = header && Math.floor(window.scrollY) > 20 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
    });
    const scrollToSavePosition = () => {
        const scrollPos = sessionStorage.getItem('scrollPosition');
        if (scrollPos) {
            window.scrollTo({
                top: parseInt(scrollPos, 10),
                behavior: 'smooth',
            });
            sessionStorage.removeItem('scrollPosition');
        }
    };
    scrollToSavePosition();
    const emailInput = document.querySelector('.js-user-email');
    const submitButton = document.querySelector('.form-box__submit-btn');
    function isValidEmail(email) {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
    }
    function updateSubmitButtonState() {
        if (emailInput && submitButton) {
            const email = emailInput.value.trim();
            submitButton.disabled = !isValidEmail(email);
        }
    }
    if (emailInput) {
        emailInput.addEventListener('input', updateSubmitButtonState);
        updateSubmitButtonState();
    }
    document.body.addEventListener('click', (event) => {
        var _a, _b;
        const target = event.target;
        const ROLE = target.dataset.role;
        if (!ROLE)
            return;
        switch (ROLE) {
            case 'smooth-scroll-to-target-element': {
                const href = target.getAttribute('href');
                if (!href || !href.startsWith('#'))
                    return;
                event.preventDefault();
                const targetElement = document.querySelector(href);
                if (targetElement) {
                    const headerOffset = 150;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
                break;
            }
            case 'filter-blog-posts': {
                const category = (_a = target.getAttribute('data-category')) !== null && _a !== void 0 ? _a : '';
                const categoryUrl = (_b = target.getAttribute('data-url')) !== null && _b !== void 0 ? _b : '';
                sessionStorage.setItem('scrollPosition', window.scrollY.toString());
                if (categoryUrl) {
                    window.location.href = categoryUrl;
                    break;
                }
                const url = new URL(window.location.href);
                url.pathname = url.pathname
                    .replace(/\/page\/\d+\//, '/')
                    .replace(/\/page\/\d+$/, '/');
                if (category === 'all') {
                    url.searchParams.delete('category');
                }
                else {
                    url.searchParams.set('category', category);
                }
                url.searchParams.delete('paged');
                window.location.href = url.toString();
                break;
            }
            case 'toggle-share-panel': {
                const shareIconsPanel = document.querySelector('.js-share-icons-panel');
                if (!shareIconsPanel)
                    return;
                shareIconsPanel.classList.toggle('is-active');
                break;
            }
            case 'back-to-top-page': {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                break;
            }
            default:
                break;
        }
    });
}
window.document.addEventListener('DOMContentLoaded', ready);
